/**
 * What is wrong with a new password, in German, or null when nothing is.
 *
 * The gateway enforces `min=8` and answers a validator sentence in English;
 * checking here means the person is told before the request, and the repeat
 * field — which the gateway knows nothing about — is checked in the same
 * place.
 */
export function passwordProblem(password: string, repeat: string): string | null {
  if (password.length < 8) return 'Das Passwort braucht mindestens 8 Zeichen.'
  if (password !== repeat) return 'Die beiden Passwörter stimmen nicht überein.'
  return null
}
